enum CriterionProvingTypeEnum {
  None = 0,
  Integration = 1 << 0,
  DocumentUpload = 1 << 1,
}

export default CriterionProvingTypeEnum;
